import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql, compose } from 'react-apollo';
import { Form, Input, DatePicker, Button, message } from 'antd';
import validationRegex from '../utils/validationRegex';

import MUTATION from '../graphql/mutations/storeCustomerPbaMutation.graphql';
import ALL_QUERY from '../graphql/queries/getCustomerPbasQuery.graphql';

const FormItem = Form.Item;

class PresentBankingArrangementForm extends Component {
  state = {
    submittingForm: false,
  };

  handleSubmit = (event) => {
    this.setState({
      submittingForm: true,
    });
    event.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      const { customer_id } = this.props;
      if (!err) {
        this.props.mutate({
          variables: { customer_id, ...values },
          update: (cache, { data: { newCustomerPba } }) => {
            const data = cache.readQuery({
              query: ALL_QUERY,
              variables: { customer_id },
            });
            if (!Array.isArray(data.customerPbas)) data.customerPbas = [];
            data.customerPbas.push(newCustomerPba);
            cache.writeQuery({ query: ALL_QUERY, variables: { customer_id }, data });
          },
        })
          .then(() => {
            this.setState({
              submittingForm: false,
            });
            this.props.form.resetFields();
            message.success('Success!');
          })
          .catch((mutateErr) => {
            console.log(mutateErr);
            this.setState({
              submittingForm: false,
            });
            message.error(mutateErr.message);
          });
      } else {
        console.log(err);
        this.setState({
          submittingForm: false,
        });
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Form onSubmit={this.handleSubmit} layout="vertical" className="bank-form">
        <FormItem
          hasFeedback
          label="Bank Name"
        >
          {
            getFieldDecorator(
              'bank_name',
              {
                rules: [
                  {
                    required: true,
                    type: 'string',
                    message: 'Field is required!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="Sanction BG/LC"
        >
          {
            getFieldDecorator(
              'sanction_bg_lc',
              {
                rules: [
                  {
                    required: true,
                    message: 'Field is required!',
                  },
                  {
                    pattern: validationRegex.float,
                    message: 'Incorrect value entered!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="Sanction TL"
        >
          {
            getFieldDecorator(
              'sanction_tl',
              {
                rules: [
                  {
                    required: true,
                    message: 'Field is required!',
                  },
                  {
                    pattern: validationRegex.float,
                    message: 'Incorrect value entered!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="Sanction CC"
        >
          {
            getFieldDecorator(
              'sanction_cc',
              {
                rules: [
                  {
                    required: true,
                    message: 'Field is required!',
                  },
                  {
                    pattern: validationRegex.float,
                    message: 'Incorrect value entered!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <h6>Outstanding Amount</h6>
        <FormItem
          hasFeedback
          label="Outstanding amount as on"
        >
          {
            getFieldDecorator(
              'oa_date',
              {
                rules: [
                  {
                    required: true,
                    message: 'Field is required!',
                  },
                ],
              },
            )(<DatePicker />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="BG/LC"
        >
          {
            getFieldDecorator(
              'oa_bg_lc',
              {
                rules: [
                  {
                    required: true,
                    message: 'Field is required!',
                  },
                  {
                    pattern: validationRegex.float,
                    message: 'Incorrect value entered!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="TL"
        >
          {
            getFieldDecorator(
              'oa_tl',
              {
                rules: [
                  {
                    required: true,
                    message: 'Field is required!',
                  },
                  {
                    pattern: validationRegex.float,
                    message: 'Incorrect value entered!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="CC"
        >
          {
            getFieldDecorator(
              'oa_cc',
              {
                rules: [
                  {
                    required: true,
                    message: 'Field is required!',
                  },
                  {
                    pattern: validationRegex.float,
                    message: 'Incorrect value entered!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="ROI"
        >
          {
            getFieldDecorator(
              'oa_roi',
              {
                rules: [
                  {
                    required: true,
                    message: 'Field is required!',
                  },
                  {
                    pattern: validationRegex.float,
                    message: 'Incorrect value entered!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="Asset Classification"
        >
          {
            getFieldDecorator(
              'oa_asset_classification',
              {
                rules: [
                  {
                    type: 'string',
                    message: 'Incorrect value entered!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem className="form-item-block">
          <Button type="primary" htmlType="submit" loading={this.state.submittingForm}>Submit</Button>
        </FormItem>
      </Form>
    );
  }
}

PresentBankingArrangementForm.propTypes = {
  mutate: PropTypes.func.isRequired,
  form: PropTypes.shape({
    getFieldDecorator: PropTypes.func,
    validateFieldsAndScroll: PropTypes.func,
    resetFields: PropTypes.func,
  }).isRequired,
  customer_id: PropTypes.string.isRequired,
};

export default compose(
  graphql(MUTATION),
  Form.create(),
)(PresentBankingArrangementForm);



// WEBPACK FOOTER //
// ./src/forms/PresentBankingArrangementForm.jsx